module.exports = __webpack_public_path__ + "static/media/fire-is-correct.6576ce57.mp3";